const config = {
    default: {
        defaultLanguage: "de",
        apiBase: [
            {
                name: "early",
                url: "/api/renz_shop_early/",
            },
            {
                name: "dev",
                url: "/api/renz_shop_dev/",
            },
            {
                name: "live",
                url: "/api/renz_shop/",
            },
        ],
        categoryImageBase: "https://images.shop.renzgroup.de/category/",
        productImageBase: "https://images.shop.renzgroup.de/product/",
        productVideoBase: "https://images.shop.renzgroup.de/videos/product/",
        productDownloadBase: "https://downloads.shop.renzgroup.de/product/",
    },
    "renz-shop-xlsx-import-2020.code.testversion.online": {
        defaultLanguage: "de",
        apiBase: [
            {
                name: "code",
                url: "https://renz-shop-2020-tibiserver.code.testversion.online/api/v1/_/renz_shop/",
            },
        ],
        categoryImageBase: "https://images.shop.renzgroup.de/category/",
        productImageBase: "https://images.shop.renzgroup.de/product/",
        productVideoBase: "https://images.shop.renzgroup.de/videos/product/",
        productDownloadBase: "https://downloads.shop.renzgroup.de/product/",
    },
    "import.fr.shop.renz24.de": {
        defaultLanguage: "fr",
        apiBase: [
            {
                name: "demo fr",
                url: "/api/renz_shop_fr/",
            },
        ],
        categoryImageBase: "https://file.fr.shop.renz24.de/images/category/",
        productImageBase: "https://file.fr.shop.renz24.de/images/product/",
        productVideoBase: "https://file.fr.shop.renz24.de/videos/product/",
        productDownloadBase: "https://file.fr.shop.renz24.de/downloads/product/",
    },
    "import.se.shop.renz24.de": {
        defaultLanguage: "se",
        apiBase: [
            {
                name: "demo se",
                url: "/api/renz_shop_se/",
            },
        ],
        categoryImageBase: "https://file.se.shop.renz24.de/images/category/",
        productImageBase: "https://file.se.shop.renz24.de/images/product/",
        productVideosBase: "https://file.se.shop.renz24.de/videos/product/",
        productDownloadBase: "https://file.se.shop.renz24.de/downloads/product/",
    },
    "import.dk.shop.renz24.de": {
        defaultLanguage: "dk",
        apiBase: [
            {
                name: "demo dk",
                url: "/api/renz_shop_dk/",
            },
        ],
        categoryImageBase: "https://file.dk.shop.renz24.de/images/category/",
        productImageBase: "https://file.dk.shop.renz24.de/images/product/",
        productVideosBase: "https://file.dk.shop.renz24.de/videos/product/",
        productDownloadBase: "https://file.dk.shop.renz24.de/downloads/product/",
    },
}

const domainConfig: {
    defaultLanguage: string
    apiBase: {
        name: string
        url: string
    }[]
    categoryImageBase: string
    productImageBase: string
    productVideoBase: string
    productDownloadBase: string
} = config[window.location.hostname] || config.default

export default domainConfig
